import React from 'react';
import { Helmet } from 'react-helmet';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { useLanguage } from '@/hooks/useLanguage';

const TermsOfService = () => {
  const { language } = useLanguage();

  return (
    <>
      <Helmet>
        <title>{language === 'de' ? 'Allgemeine Geschäftsbedingungen (AGB)' : 'Terms of Service'} | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin</title>
        <meta name="description" content={language === 'de'
          ? 'Allgemeine Geschäftsbedingungen (AGB) von Matthias Meyfarth aus Berlin für Videoproduktion, Fotografie und Webdesign.'
          : 'Terms of Service of Matthias Meyfarth from Berlin for videography, photography, and web design.'} />
        <meta property="og:title" content={language === 'de'
          ? 'AGB | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin'
          : 'Terms of Service | Matthias Meyfarth – Videograf, Fotograf & Webdesigner from Berlin'} />
        <meta property="og:description" content={language === 'de'
          ? 'Die AGB von Matthias Meyfarth für kreative Dienstleistungen aus Berlin.'
          : 'The Terms of Service of Matthias Meyfarth for creative services from Berlin.'} />
        <meta property="og:type" content="website" />
      </Helmet>

      <Navigation />

      <main className="container mx-auto px-6 py-24">
        <h1 className="text-4xl font-bold mb-8">
          {language === 'de' ? 'Allgemeine Geschäftsbedingungen (AGB)' : 'Terms of Service'}
        </h1>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            {language === 'de' ? 'Geltungsbereich' : 'Scope of Application'}
          </h2>
          <p className="mb-4">
            {language === 'de'
              ? 'Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge, die zwischen Matthias Meyfarth und seinen Kunden geschlossen werden.'
              : 'These Terms of Service apply to all contracts concluded between Matthias Meyfarth and his clients.'}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            {language === 'de' ? 'Leistungen' : 'Services'}
          </h2>
          <p className="mb-4">
            {language === 'de'
              ? 'Matthias Meyfarth bietet Dienstleistungen in den Bereichen Videoproduktion, Fotografie und Webdesign an.'
              : 'Matthias Meyfarth offers services in the fields of videography, photography, and web design.'}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            {language === 'de' ? 'Vertragsschluss' : 'Conclusion of Contract'}
          </h2>
          <p className="mb-4">
            {language === 'de'
              ? 'Ein Vertrag kommt durch die Annahme eines Angebots von Matthias Meyfarth durch den Kunden zustande.'
              : 'A contract is concluded when a client accepts an offer from Matthias Meyfarth.'}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            {language === 'de' ? 'Haftung' : 'Liability'}
          </h2>
          <p className="mb-4">
            {language === 'de'
              ? 'Matthias Meyfarth haftet nur für Schäden, die auf vorsätzlichem oder grob fahrlässigem Verhalten beruhen.'
              : 'Matthias Meyfarth is only liable for damages resulting from intentional or grossly negligent behavior.'}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold mb-4">
            {language === 'de' ? 'Schlussbestimmungen' : 'Final Provisions'}
          </h2>
          <p className="mb-4">
            {language === 'de'
              ? 'Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist Berlin, soweit gesetzlich zulässig.'
              : 'The law of the Federal Republic of Germany applies. The place of jurisdiction is Berlin, as far as legally permissible.'}
          </p>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default TermsOfService;
